import { useDragLayer } from 'react-dnd'

import { RowDragPreview } from '../GridTable/DragDropGrid/RowDragPreview'
import { GridTableDragType } from '../GridTable/models/GridTableDragType'
import { getItemStyles, layerStyles } from './CustomDragLayerStyles'

export type CustomDragLayerProps = {
  //
}

export const CustomDragLayer: React.FC<CustomDragLayerProps> = () => {
  const {
    itemType,
    isDragging,
    item,
    initialOffset,
    currentOffset,
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }))

  if (!isDragging) {
    return null
  }

  // Render any custom drag preview based on the item type here.
  // Note that the drag item default preview should be disabled by rendering an empty image.
  const renderItem = () => {
    if (itemType === GridTableDragType.ROW
      || itemType === GridTableDragType.SHIFT_STOP_ROW
      || itemType === GridTableDragType.INBOX_ORDER_ROW
      || itemType === GridTableDragType.UNASSIGNED_ORDER_ROW
    ) {
      return <RowDragPreview item={item} />
    }

    return null
  }

  const renderPreview = renderItem()

  if (!renderPreview) {
    return null
  }
  
  // Because of the limitations of the drag backend, we have to set none pointer event
  //   and cannot set a custom cursor on the drag overlay
  return (
    <div style={layerStyles}>
      <div style={getItemStyles(initialOffset, currentOffset)}>
        {renderPreview}
      </div>
    </div>
  )
}
